module.exports = __webpack_public_path__ + "static/media/galeryFloating7.fe630b5f.jpg";